import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=be4684de&scoped=true&"
import script from "./Integrations.vue?vue&type=script&lang=js&"
export * from "./Integrations.vue?vue&type=script&lang=js&"
import style0 from "./Integrations.vue?vue&type=style&index=0&id=be4684de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4684de",
  null
  
)

export default component.exports